<template>
<DIV>
  <UcMeterTypeIcon
  v-if="option.meter_type"
  :type="option.meter_type"
  :color="option.inactive ? $config.colors.inactiveRed : $config.colors.activeGreen"
></UcMeterTypeIcon>
<ItpText :text="option.serial_number" spacing="mx-1"></ItpText>
<ItpText :text="option.deveui" spacing="mx-1"></ItpText>
<ItpText :text="option.tag_id" spacing="mx-1"></ItpText>
<ItpText :text="option.model_name" small muted spacing="mx-1"></ItpText>

</DIV>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcSuggestMeterOption extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    type: Object,
  })
  option!: object;

  @Watch('option')
  onOption(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("option")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("UcSuggestMeterOption", UcSuggestMeterOption);

</script>